import {
  IUserLoginOutput,
  IUserForgetPasswordInput,
  IUserResetPasswordOutput,
  IUserCheckCodeInput,
  IUserCheckCodeOutput,
  IUserMobileInput,
  IAuthOTPInput,
  IAuthOTPOutput,
  IValidateAuthOTPOutput,
  IValidateAuthOTPInput,
  IUserLoginInput2,
  IUserForgetPassword2Output,
  IForgetPasswordInput,
  ICheckCodeInput,
  IDevicesOtp,
  IDeviceOtpValidate,
  IDeviceList,
  ILogoutDevice,
} from "@types";
import gate from "../gate";
import client from "../http-clients/api";

const auth = {
  refresh: (params: any) =>
    gate.post<any, never, any>({
      client,
      url: "/TokenAuth/RefreshToken",
      data: undefined,
      params: params,
    }),
  resetPass: (data: IUserResetPasswordOutput) =>
    gate.post<IUserForgetPasswordInput, IUserResetPasswordOutput, never>({
      client,
      url: "/auth/password/change",
      data,
    }),
  checkCode: (data: IUserCheckCodeInput) =>
    gate.post<IUserForgetPasswordInput, IUserCheckCodeInput, never>({
      client,
      url: "/auth/password/check",
      data,
    }),
  remainTime: (params: IUserMobileInput) =>
    gate.get<Response, never, any>({
      client,
      url: "/password/forgot/remain/time",
      params: params,
    }),
  logout: () =>
    gate.post<any, never, never>({
      client,
      url: "auth/logout",
    }),
  authOTP: (data: IAuthOTPOutput) =>
    gate.post<IAuthOTPInput, IAuthOTPOutput, never>({
      client,
      url: "/auth/otp",
      data,
    }),
  authOTPByCall: (data: IAuthOTPOutput) =>
    gate.post<IAuthOTPInput, IAuthOTPOutput, never>({
      client,
      url: "/auth/otp?retry_otp=true",
      data,
    }),
  validateAuthOTP: (data: IValidateAuthOTPOutput) =>
    gate.post<IValidateAuthOTPInput, IValidateAuthOTPOutput, never>({
      client,
      url: "/auth/otp/validate",
      data,
    }),
  basicLogin: (data: IUserLoginOutput) =>
    gate.post<IUserLoginInput2, IUserLoginOutput, never>({
      client,
      url: "/auth/basic",
      data,
    }),
  forgetPassword: (data: IUserForgetPassword2Output) =>
    gate.post<IForgetPasswordInput, IUserForgetPassword2Output, never>({
      client,
      url: "/auth/password/forgot",
      data,
    }),
  checkCodeV2: (data: IUserCheckCodeOutput) =>
    gate.post<ICheckCodeInput, IUserCheckCodeOutput, never>({
      client,
      url: "/password/check",
      data,
    }),
  socialLogin: (
    type: "google" | "linkedin",
    data: { access_token: string; device_name?: string },
  ) =>
    gate.post<any, { access_token: string }, never>({
      client,
      url: `/auth/social-front/${type}`,
      data,
    }),
  verifyDevicesOtp: (data: { username: string }) =>
    gate.post<IDevicesOtp, { username: string }, never>({
      client,
      url: "/users/devices/otp",
      data,
    }),
  verifyDevicesOtpValidate: (data: { username: string; code: string }) =>
    gate.post<IDeviceOtpValidate, { username: string; code: string }, never>({
      client,
      url: "/users/devices/otp/validate",
      data,
    }),
  getDevices: (data: { temp_id: string }) =>
    gate.post<IDeviceList, { temp_id: string }, never>({
      client,
      url: "/users/devices/get",
      data,
    }),
  logoutDevice: (data: { temp_id: string; token_id: string }) =>
    gate.post<ILogoutDevice, { temp_id: string; token_id: string }, never>({
      client,
      url: "/users/devices/logout",
      data,
    }),
  loginTempId: (data: { temp_id: string; device_name?: string }) =>
    gate.post<IUserLoginInput2, { temp_id: string }, never>({
      client,
      url: "/auth/token",
      data,
    }),
};

export default auth;
